import { ServerResponse } from './serverResponse';
import { User } from './user';

export class Message extends ServerResponse {
  id: number;
  text: string;
  type: string;
  status: number;
  author: User | number;
  room: number;
  unit_room: number;
  company: number;
  unit: any;
  is_waiting: boolean;
  is_read: boolean;
  application: number;
  applicant_name: string;
  created_at?: string;

  constructor(
    text: string,
    room: number = null,
    unit_room = null,
    unit: any,
    is_waiting: boolean = false,
    type: string = 'Message',
    application: number = null
  ) {
    super();
    this.text = text;
    this.room = room;
    this.unit_room = unit_room;
    this.unit = unit;
    this.is_waiting = is_waiting;
    this.type = type;
    this.application = application;
  }
}
